import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
//plugins
import NowUIKit from "./plugins/now-ui-kit";

import ApolloClient from "apollo-boost";
import VueApollo from "vue-apollo";
import axios from 'axios';
import store from './store/index'
import swal from "sweetalert2";
import auth from './store/auth/index';
import VueMeta from "vue-meta";

axios.defaults.baseURL = process.env.VUE_APP_apiServerUrl;

Vue.config.productionTip = false;
Vue.use(NowUIKit);
Vue.use(VueApollo);
Vue.use(VueMeta);

const apolloOptions = {
  onError: (error) => {
    console.error(error);
    if(error.networkError) {
      if (error.networkError.statusCode && error.networkError.statusCode === 401) {
        console.log('401 logout');
        router.push({name: 'Logout401'});
        return;
      } else {
        swal.fire({
          icon: 'error',
          title: '伺服器出現錯誤',
          text: '請聯絡技術人員或稍後再試',
        });
        router.push({name: 'Home'});
      }
    }
    if(error.graphQLErrors) {
      const firstGQLError = error.graphQLErrors[0];
      swal.fire({
        icon: 'error',
        title: firstGQLError.message,
        text: '請聯絡技術人員或稍後再試',
      });
      router.push({name: 'Home'});
    }
  },
  request: operation => {
    const token = localStorage.getItem("token") || "";

    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}`: ''
      }
    });
  },
};

const gqlApi = new ApolloClient({
  ...apolloOptions,
  uri: process.env.VUE_APP_graphqlServerUrl
});

const apolloProvider = new VueApollo({
  clients: {
    gqlApi
  },
  defaultClient: gqlApi,
  defaultOptions: {
    $query: {
      loadingKey: 'loading',
      fetchPolicy: 'no-cache',
    },
  },
});

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount("#app");
